import React from 'react';
import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';
import stock_list from './stock.list';
import stock_detail from './stock.detail';

/**
 *   Create index file
 */

export default function StockIndex() {
  let {
    slug = 'list'
  } = useParams();
  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = stock_list;
      break;
    case 'view':
      ActualPage = stock_detail;
      break;
    default:
      ActualPage = Theme404;
      break;
  }
  return <>{<ActualPage />}</>;
}